import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import Vue from "vue";

export default Sentry.init.bind(window, {
  Vue,
  environment: process.env.NODE_ENV,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  attachProps: true,
  logErrors: true,
  integrations: [
    new Integrations.BrowserTracing()
  ],
  tracingOptions: {
    trackComponents: true
  }
});
